import React from 'react'

import { DescriptionList, Item, ItemProps } from 'src/components/DescriptionList'
import { Link } from 'react-router-dom'
import { DistributionDetailsById } from 'src/queries'
import { ContractLink } from 'src/components/Links'

interface ListProps {
  distribution: DistributionDetailsById | undefined
}

const List: React.FC<ListProps> = (props) => {
  const { distribution } = props
  const position = distribution?._position ?? undefined
  const section: Array<Omit<ItemProps, 'id'>> = [
    {
      title: 'Position Number',
      value: position !== undefined
        ? (
          <Link to={`/cat/positions/${position._id}`}>{position?.id}</Link>
          )
        : null
    },
    {
      title: 'Position Title',
      value: position !== undefined
        ? (
          <Link to={`/cat/positions/${position._id}`}>{position?.title}</Link>
          )
        : null
    },
    {
      title: 'Contract',
      value: (
        <ContractLink _id={position?._contract?._id}>
          {position?._contract?.abbreviation}
        </ContractLink>
      )
    }
  ]
  const dlProps = {
    className: 'row-cols-1',
    suspended: distribution === undefined,
    titleProps: { lg: 'auto' },
    valueProps: { lg: 'auto', className: 'mb-lg-0 mb-md-1 mb-3' }
  }
  return (
    <DescriptionList {...dlProps}>
      {section.map(item => {
        const key = item.title.toLowerCase().replace(' ', '-')
        return <Item {...item} key={key} id={key} />
      })}
    </DescriptionList>
  )
}

export default List
